var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-linear',{attrs:{"active":_vm.loading,"indeterminate":_vm.loading ? _vm.loading : false,"absolute":_vm.absolute ? _vm.absolute : false,"fixed":_vm.fixed,"top":"","color":"yellow lighten-2","height":_vm.height ? _vm.height : 8}})
}
var staticRenderFns = []

export { render, staticRenderFns }